// Spanish for the SOS Field app: top bar, menu, location and department screens, upload status.
// Keys are the English text exactly as written in the code. iPhone/Android setting names are the ones
// those phones show in Spanish.
export default {
  'Could not switch department': 'No se pudo cambiar de departamento',
  '{count} photo(s) have not uploaded yet. They stay on this phone and upload after you sign in again. Sign out?':
    '{count} foto(s) todavía no se han subido. Se quedan en este teléfono y se suben cuando vuelvas a entrar. ¿Salir?',
  Back: 'Atrás',
  'Department: {name}. Tap to switch.':
    'Departamento: {name}. Toca para cambiar.',
  'Sign out': 'Salir',
  'Employee app': 'App de empleados',
  Home: 'Inicio',
  Clocks: 'Reloj',
  Sales: 'Ventas',
  'Which department today?': '¿En qué departamento trabajas hoy?',
  'Your photos go to this department’s folder. You can switch later.':
    'Tus fotos van a la carpeta de este departamento. Puedes cambiarlo después.',
  'Turning on location…': 'Activando la ubicación…',
  'When your phone asks, tap': 'Cuando el teléfono te pregunte, toca',
  Allow: 'Permitir',
  'CompanyCam needs your location to stamp every photo and find your job.':
    'CompanyCam necesita tu ubicación para marcar cada foto y encontrar tu trabajo.',
  'Location is off': 'La ubicación está apagada',
  'You can’t use CompanyCam without location. Turn it on, then tap':
    'No puedes usar CompanyCam sin ubicación. Actívala y luego toca',
  'Try again': 'Intentar de nuevo',
  Open: 'Abre',
  Settings: 'Ajustes',
  'Privacy & Security': 'Privacidad y seguridad',
  'Location Services': 'Localización',
  'and make sure it’s on.': 'y revisa que esté activada.',
  'In the same screen, open': 'En la misma pantalla, abre',
  'Safari Websites': 'Sitios web de Safari',
  '(or your browser) and choose': '(o tu navegador) y elige',
  'While Using the App': 'Mientras se usa la app',
  'Back in Safari, tap': 'De vuelta en Safari, toca',
  'in the address bar': 'en la barra de direcciones',
  'Website Settings': 'Ajustes del sitio web',
  Location: 'Ubicación',
  'Tap the icon left of the address bar':
    'Toca el ícono a la izquierda de la barra de direcciones',
  Permissions: 'Permisos',
  'Make sure the phone’s location is on (swipe down from the top of the screen).':
    'Revisa que la ubicación del teléfono esté activada (desliza hacia abajo desde arriba de la pantalla).',
  'Looking for GPS…': 'Buscando GPS…',
  'We can’t find your location yet. Step outside or near a window and wait a few seconds.':
    'Todavía no encontramos tu ubicación. Sal afuera o acércate a una ventana y espera unos segundos.',
  'This browser can’t share location':
    'Este navegador no puede compartir la ubicación',
  'Open CompanyCam in Safari (iPhone) or Chrome (Android).':
    'Abre CompanyCam en Safari (iPhone) o Chrome (Android).',
  'No signal.': 'Sin señal.',
  '1 photo saved on this phone.': '1 foto guardada en este teléfono.',
  '{count} photos saved on this phone.':
    '{count} fotos guardadas en este teléfono.',
  'Uploads resume when you reconnect.':
    'Se siguen subiendo cuando vuelva la señal.',
  'Uploading 1 photo…': 'Subiendo 1 foto…',
  'Uploading {count} photos…': 'Subiendo {count} fotos…',
  'Keep this page open.': 'Deja esta página abierta.',
  '1 photo could not upload.': '1 foto no se pudo subir.',
  '{count} photos could not upload.': '{count} fotos no se pudieron subir.',
  'Open the job to retry.': 'Abre el trabajo para intentar de nuevo.',
  'Switch department': 'Cambiar de departamento',
} as Record<string, string>
